import Paper from '@/components/Paper'
import SubHeaders from '@/components/Headers/SubHeaders'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import AddIcons from '@/icons/AddIcons'
import { paths } from '@/utils/path'
import { IPermissionProps } from '@/types/shared'

import { useVCardList } from '../../hooks/use-vcard-list'

const List: React.FC<IPermissionProps> = () => {
    const {
        vcards,
        pagination,
        stateComponent,
        params,
        searchInputProps,
        columns,
        actions,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        navigate,
        t,
    } = useVCardList()

    return (
        <div className="space-y-2">
            <SubHeaders
                actions={[
                    {
                        icon: <AddIcons />,
                        label: t('create'),
                        variant: 'contained',
                        onClick: () => navigate(paths.vcardCreatePage),
                    },
                ]}
                breadcrumbs={[
                    {
                        path: paths.vcardList,
                        title: t('vcard_list'),
                    },
                ]}
            />

            <Paper>
                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={vcards}
                        rowKey={(row) => row.id}
                        size="small"
                        actions={actions}
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: t('search'),
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                )}
            </Paper>
        </div>
    )
}

export default List
